import { observer } from 'mobx-react-lite';
import { isFeatureEnabled } from 'owa-feature-flags';
import { IsChildConsumerUser, IsShadowMailboxUser } from 'owa-mail-ads-shared/lib/sharedAdsUtils';
import selectDefaultFolder from 'owa-mail-folder-forest-actions/lib/actions/selectDefaultFolder';
import { FolderPane } from 'owa-mail-folder-forest-view';
import { LeftnavUpsell } from 'owa-mail-leftnavupsell';
import ModuleSwitcher, { Module } from 'owa-module-switcher';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import * as React from 'react';
import { OfficeAppRail } from 'owa-office-app-rail';

interface FolderPaneContainerProps {
    isLeftRailVisible: boolean;
    leftNavWidth: number;
}

const styles = require('./MailModule.scss');

export default observer(function FolderPaneContainer(props: FolderPaneContainerProps) {
    const showLeftNavPremiumUpsell =
        !IsShadowMailboxUser() &&
        isFeatureEnabled('auth-leftNavPremiumUpsell') &&
        !IsChildConsumerUser() &&
        getUserConfiguration().SessionSettings.UserCulture.indexOf('jp') === -1;

    const showOfficeAppRail: boolean =
        isFeatureEnabled('sig-LeftNavOfficeButtonsTreatment1') ||
        isFeatureEnabled('sig-LeftNavOfficeButtonsTreatment2');

    const onModuleClicked = React.useCallback(() => {
        selectDefaultFolder('ModuleSwitcher');
    }, []);

    return (
        <div className={styles.leftColumn}>
            <FolderPane />
            {showLeftNavPremiumUpsell && <LeftnavUpsell />}
            {!props.isLeftRailVisible && (
                <>
                    <ModuleSwitcher
                        selectedModule={Module.Mail}
                        activeModuleAction={onModuleClicked}
                        isHorizontal={true}
                        containerWidth={props.leftNavWidth}
                    />
                    {showOfficeAppRail && (
                        <OfficeAppRail isHorizontal={true} containerWidth={props.leftNavWidth} />
                    )}
                </>
            )}
        </div>
    );
});
